import React from "react"; 
import { Link } from "react-router-dom";
import './LegalMention.css';
import Header from '../../../components/common/Header/header';


export default function LegalMention() {
    return (
        <div className="legal-mention-container">

            <div className="legal-mention-header">
                <Header />
            </div>

            <div className="legal-mention-content">
                <h1>Mentions légales</h1>

                <h2>Éditeur du site</h2>
                <p>
                    <strong>De Lisle</strong><br />
                    Jérémy Delisle<br />
                    “adresse sur demande”<br />
                    Email : contact@delislecouture.com<br />
                    Responsable de la publication : Jérémy Delisle
                </p>

                <hr />

                <h2>Hébergement</h2>
                <p>
                    <strong>Frontend (site web)</strong><br />
                    Firebase – Google LLC<br />
                    1600 Amphitheatre Parkway<br />
                    Mountain View, CA 94043, États-Unis<br />
                    <a href="https://firebase.google.com/" target="_blank" rel="noopener noreferrer">
                        https://firebase.google.com/
                    </a>
                </p>
                <p>
                    <strong>Backend (API serveur)</strong><br />
                    Infomaniak Network SA<br />
                    Avenue de la Praille, 26 – 1227 Carouge – Suisse<br />
                    <a href="https://www.infomaniak.com/" target="_blank" rel="noopener noreferrer">
                        https://www.infomaniak.com/
                    </a>
                </p>

                <hr />

                <h2>Nature du site : partage bénévole, sans but lucratif</h2>
                <p>
                    Le présent site est un site strictement personnel, édité à titre bénévole et sans but lucratif.
                    Son unique finalité est le <strong>partage gratuit des créations</strong> de son auteur, Jérémy Delisle.
                </p>
                <p>
                    Le site n'exerce <strong>aucune activité commerciale ou lucrative</strong> : aucune vente, aucune
                    prestation rémunérée, aucune publicité, aucun service payant. Aucun revenu, en espèces ou en nature,
                    n'est tiré de son exploitation. Les frais d'hébergement et de fonctionnement sont supportés par l'éditeur.
                </p>

                <hr />

                <h2>Propriété intellectuelle</h2>
                <p>
                    Tous les contenus présents sur ce site (textes, images, créations, marques, logos, etc.) sont la propriété exclusive de <strong>De Lisle</strong> ou de ses partenaires.<br />
                    Les créations présentées sont partagées à titre gracieux et ne sont pas mises en vente.<br />
                    Toute reproduction, distribution ou utilisation sans autorisation préalable est interdite.
                </p>

                <hr />

                <h2>Données personnelles</h2>
                <p>
                    Le site ne collecte aucune donnée personnelle des visiteurs en dehors des informations que vous
                    transmettez volontairement via le formulaire de contact. Ces données sont utilisées exclusivement
                    pour répondre à votre message ; elles ne sont ni cédées à des tiers, ni utilisées à des fins
                    commerciales, de marketing ou de suivi.<br />
                    Seule l'authentification pour l'accès à l'espace administrateur (réservé) utilise Firebase Auth, stockée de manière sécurisée.<br />
                    Le présent site étant sans but lucratif et à usage personnel, il est exploité conformément à la
                    loi fédérale sur la protection des données (LPD).
                </p>
                <p>
                    Le site utilise Google Fonts via un service tiers (Google Fonts) pour afficher les polices de caractères.<br />
                    Lors du chargement des polices, votre navigateur peut envoyer des données à Google, notamment votre adresse IP.<br />
                    Cette opération est susceptible d'être considérée comme un traitement de données personnelles.<br />

                    Certaines pages du site peuvent contenir des vidéos intégrées depuis YouTube.<br />
                    En visualisant ces vidéos, des cookies tiers déposés par Google/YouTube peuvent être installés sur votre appareil.<br />
                    Pour limiter ces cookies, ce site utilise le mode « nocookie » de YouTube lorsque cela est possible.<br />
                    Pour plus d'informations, veuillez consulter la&nbsp;
                    <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                        politique de confidentialité de Google
                    </a>.
                </p>


                <hr />

                <h2>Cookies et technologies de suivi</h2>
                <p>
                    Ce site n'utilise <strong>aucun cookie de suivi, d'analyse ou de publicité</strong>.
                </p>

                <h2>Cookies techniques essentiels</h2>
                <p>
                    Les seuls cookies utilisés sont des <strong>cookies strictement nécessaires</strong> au fonctionnement du site, déposés par Firebase Authentication pour gérer les sessions utilisateur :
                </p>
                <ul>
                    <li><strong>Firebase Auth Cookies :</strong> Permettent de maintenir votre session de connexion active lorsque vous créez un compte ou vous connectez. Ces cookies expirent automatiquement lors de la déconnexion ou après 1 heure d'inactivité</li>
                </ul>

                <h2>Stockage local (Session Storage)</h2>
                <p>
                    Le site utilise le <strong>Session Storage</strong> du navigateur pour stocker temporairement :
                </p>
                <ul>
                    <li><strong>Identifiant utilisateur (userId)</strong> : Permet de vous identifier pendant votre session</li>
                    <li><strong>Identifiant Firebase (firebaseUid)</strong> : Nécessaire pour l'authentification</li>
                    <li><strong>Email utilisateur</strong> : Affiché dans votre espace personnel</li>
                    <li><strong>Statut administrateur (isAdmin)</strong> : Détermine l'accès aux fonctions d'administration</li>
                </ul>
                <p>
                    Ces données sont <strong>automatiquement supprimées</strong> lorsque vous fermez votre navigateur ou vous déconnectez.
                </p>

                <h2>Consentement</h2>
                <p>
                    Les cookies et technologies de stockage utilisés sur ce site étant strictement nécessaires au fonctionnement du service, aucun bandeau de consentement n'est requis conformément à la réglementation en vigueur.
                </p>

                <hr />

                <h2>Contact et informations légales</h2>
                <p>
                    Pour toute question concernant vos données personnelles, vos commandes ou nos services :
                </p>
                <ul>
                    <li><Link to="/contact">Formulaire de contact</Link></li>
                    <li>Email : <strong>contact@delislecouture.com</strong></li>
                </ul>

                <div className="legal-mention-footer">
                    <p>&copy; {new Date().getFullYear()} De Lisle. Tous droits réservés.</p>
                </div>
            </div>
        </div>
    );
};